/* Homepage dedupe (Youssef, 21 Oct 2026): a product shows once on the homepage.
   Walks the page in order. [data-dedupe-seen] marks a product as shown (ticker items). Each [data-dedupe-rail]
   keeps its first data-dedupe-limit cards whose product is not shown higher up and hides the rest (the spares
   the section rendered for refills). A rail with data-dedupe-lead also moves its first kept product into the
   matching lead slot ([data-cl-lead]). Before this runs, CSS shows each rail's first N cards.
   Each rail section includes this file right after its markup, so it runs while the page is parsed, before the theme's
   reveal and lazy-load scripts start; every run recomputes from the top, so repeated runs give the same result. */
(function () {
  if (window.mymHomeDedupe) { window.mymHomeDedupe(); return; }
  function run() {
    var seen = new Set();
    document.querySelectorAll('[data-dedupe-seen], [data-dedupe-rail]').forEach(function (el) {
      if (el.hasAttribute('data-dedupe-seen')) { seen.add(el.getAttribute('data-dedupe-seen')); return; }
      var limit = parseInt(el.getAttribute('data-dedupe-limit'), 10) || 0;
      var keep = [];
      Array.prototype.forEach.call(el.children, function (item) {
        var id = item.getAttribute('data-dedupe-pid');
        if (!id) return;
        var ok = keep.length < limit && !seen.has(id) && keep.indexOf(id) === -1;
        item.hidden = !ok;
        if (ok) keep.push(id);
      });
      keep.forEach(function (id) { seen.add(id); });
      if (el.hasAttribute('data-dedupe-lead')) {
        var scope = el.closest(el.getAttribute('data-dedupe-lead'));
        var leadId = keep[0];
        if (scope) scope.querySelectorAll('[data-cl-lead]').forEach(function (lead) { lead.hidden = lead.getAttribute('data-cl-lead') !== leadId; });
        Array.prototype.forEach.call(el.children, function (item) { if (item.getAttribute('data-dedupe-pid') === leadId) item.hidden = true; });
        if (scope) scope.classList.add('is-deduped');
      }
      el.classList.add('is-deduped');
    });
  }
  window.mymHomeDedupe = run;
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
